import {
  ErrorDialogContext,
  errorHandledAsync,
} from "@/shared/context/error-context";
import { DeleteAccountGroupsService } from "@/features/accounts/account-group/services/delete-account-groups-service";
import { LoadingModalContext } from "@/shared/components/loading/loading-context";
import { useState, useContext } from "react";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";

interface Props {
  onTapCompleteModal: () => void;
}

export const useDeleteAccountGroups = ({ onTapCompleteModal }: Props) => {
  const {
    accountGroups,
    targetAccountGroup,
  } = useAccountGroupsContext();

  const [deleteResult, setDeleteResult] = useState(0);

  const { setError } = useContext(ErrorDialogContext);
  const loadingCtx = useContext(LoadingModalContext);

  const deleteAccountGroupsService = new DeleteAccountGroupsService();

  const onClickDelete = async () => {
    if (accountGroups.length <= 1) {
      // 最低1つは口座グループを登録しておく必要がある
      setDeleteResult(1);
      return;
    }
    const ownerAccountGroups = accountGroups.filter((group) => group.isOwner === 1);
    if (ownerAccountGroups.length <= 1) {
      // 最低1つは自分の口座グループを登録しておく必要がある
      setDeleteResult(4);
      return;
    }
    if (targetAccountGroup.accountsList.length > 0) {
      // 口座が設定されているグループは削除できない
      setDeleteResult(2);
      return;
    }

    // 口座グループの削除確認
    setDeleteResult(5);
    return;
  };

  // 口座グループ削除
  const deleteAccountGroups = async (
    accountGroupId: string
  ) => {
    loadingCtx.setIsLoading(true);
    try {
      await deleteAccountGroupsService.deleteAccountGroups({
        account_group_id: accountGroupId,
      });
    setDeleteResult(3);
    } catch (error) {
      // エラーハンドリング
      console.log("deleteAccountGroups:", error);
    } finally {
      loadingCtx.setIsLoading(false);
    }
  };

  return {
    deleteResult,
    setDeleteResult,
    onClickDelete: errorHandledAsync(onClickDelete, setError),
    deleteAccountGroups: errorHandledAsync(deleteAccountGroups, setError),
  };
};
